export class AppConstants {
    public static IMAGE_PATH_PAYMENT_OPTIONS = './assets/images/payment-options/';
    public static IMAGE_PATH_OTHERS = './assets/images/';
    public static IMAGE_EXTENSION = '.svg';
    public static CORAL = 'CORAL';
    public static CORAL_FEID = 'cl';
    public static DEPOSIT_INPUT = '1';
    public static DEPOSIT_SUCCESS = '2';
    public static DEPOSIT_FAILURE = '3';
    public static LADBROKEUK = 'LADBROKEUK';
    public static V2 = 'v2';
    public static V3 = 'v3';
    public static FLASH1VOUCHER = 'FLASH1VOUCHER';
    public static PIX = 'PIX';
    public static AMEX = 'AMEX';
    public static PREPAID = 'prepaid';
    public static CCFAMILY = ['VISA', 'MASTERCARD', 'GAMERSCARD', 'ENTROPAY', 'DINERS', 'MLIFE', 'DANKORT', 'VISA-QUWI', 'AMEX', 'DISCOVER'];
    public static PREPAIDCARDS = ['BORGATAPREPAIDCARD', 'PLAYMGMPREPAIDCARD', 'PARTYPREPAIDCARD'];
    public static PREPAIDCARDSAndECHECKS = [
        'BORGATAPREPAIDCARD',
        'PLAYMGMPREPAIDCARD',
        'PARTYPREPAIDCARD',
        'MLIFE',
        'INSTANTECHECKS',
        'INTERCHECKS_ACH',
    ];
}

//Timer Units Type
export class TimerUnitsType {
    public static HOURS: string = 'HOURS';
    public static MINUTES: string = 'MINUTES';
    public static SECONDS: string = 'SECONDS';
}

export class ProductType {
    public static POKER = 'POKER';
    public static SPORTS = 'SPORTS';
    public static SPORTSBOOK = 'SPORTSBOOK';
    public static CASINO = 'CASINO';
    public static BETTING = 'BETTING';
    public static BINGO = 'BINGO';
}

export class BrandType {
    public static CORAL = 'CORAL';
}

export class ProposedProduct {
    public static SLOTSANDPOKER = 'Slots and Poker';
    public static SLOTS = 'Slots';
    public static POKER = 'Poker';
    public static SPORTS = 'Sports';
}

export class PageName {
    public static KYCLimitsExceeded = 'KYCLimitsExceeded';
    public static GamingLimitsNotConfigured = 'gamingLimitsNotConfigured';
    public static ProrgDepLimitExceeded = 'prorgDepLimitExceeded';
    public static AMLNetDepositLimitsExceeded = 'AMLNetDepositLimitsExceeded';
    public static AffordibilityNetDepositLimitsExceeded = 'AffordibilityNetDepositLimitsExceeded';
    public static SvocAffordibilityNetDepositLimitsExceeded = 'SvocAffordibilityNetDepositLimitsExceeded';
    public static PurchaseLimitsExceeded = 'PurchaseLimitsExceeded';
    public static CentralDepLimitsExceeded = 'CentralDepLimitsExceeded';
    public static DepositLimitsExceeded = 'DepositLimitsExceeded';
    public static InstrumentLimitExceeded = 'InstrumentLimitExceeded';
    public static GamerscardErrorCodes = 'GamerscardErrorCodes';
    public static CreditCardBlockDetails = 'CreditCardBlockDetails';
    public static ArcDepositDecline = 'ArcDepositDecline';
    public static DoNotHonorMessage = 'DoNotHonorMessage';
    public static InsufficientFunds = 'InsufficientFunds';
    public static Flash1VoucherError = 'Flash1VoucherError';
    public static DepositDecline = 'DepositDecline';
    public static IntensivePlayerMessage = 'IntensivePlayerMessage';
    public static RiskPlayerMessage = 'RiskPlayerMessage';
}
export class InputType {
    public static PAYPAL = 'PAYPAL';
    public static CANADIANEFT = 'CANADIANEFT';
    public static SKRILL1TAP = 'SKRILL1TAP';
    public static VENMO = 'VENMO';
    public static INSTANTECHECKS = 'INSTANTECHECKS';
    public static FLASH1VOUCHER = 'FLASH1VOUCHER';
    public static PREPAIDCARD = 'PREPAIDCARD';
    public static PAYPALDIRECT = 'PAYPALDIRECT';
    public static VISA = 'VISA';
    public static PLAYMGMPREPAIDCARD = 'PLAYMGMPREPAIDCARD';
    public static BORGATAPREPAIDCARD = 'BORGATAPREPAIDCARD';
    public static PARTYPREPAIDCARD = 'PARTYPREPAIDCARD';
    public static NONPAYPAL = 'NONPAYPAL';
    public static APPLEPAY = 'APPLEPAY';
    public static APPLEPAYDIRECT = 'APPLEPAYDIRECT';
    public static allDepositOptions = 'allDepositOptions';
    public static MLIFE = 'MLIFE';
    public static PIX = 'PIX';
}

export class Config {
    public static YES = 'Y';
}

export class Jurisdiction {
    public static DEU = 'DEU';
}

export class Country {
    public static US = 'US';
    public static GB = 'GB';
    public static NL = 'NL';
}

export class ChannelType {
    public static WC = 'WC';
    public static VC = 'VC';
    public static FC = 'FC';
    public static MC = 'MC';
    public static AN = 'AN';
    public static IN = 'IN';
    public static AW = 'AW';
    public static IW = 'IW';
    public static IH = 'IH';
    public static MW = 'MW';
}

export class CurrencyCode {
    public static ZAR = 'ZAR';
}

export class LiveChatResponse {
    public static LiveChatResponse_1001 = '1001';
    public static LiveChatResponse_1000 = '1000';
}

export const LIMIT_PERIOD = ['Daily', 'Weekly', 'Monthly'];
export const GEOCOMPLY_INIT_SOURCE = 'QD-Deposit';
export const MOBILE_APP_CHANNELS = ['AH', 'AW', 'AN', 'IH', 'IW', 'IN'];

export const CURRENCY_NARROW_DISPLAY_LIST = ['zar', 'cop', 'cad'];
export const QR_CODE_COPIED_MESSAGE_TIMEOUT = 5000;

export class PROVIDER_NAME {
    public static OKTO = 'OKTO';
}
